module.exports = __webpack_public_path__ + "img/arrow_expand.f24eefbe.svg";